import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

export const editDetailedSummaryModalSchema = yupResolver(
  yup.object({
    provisions: yup.string().test('greater-than-or-equal-zero', 'O valor deve ser positivo', (value) => {
      if (!value || value.trim() === '') return true
      const numericValue = Number(value)
      return !isNaN(numericValue) && numericValue >= 0
    }),
    reversals: yup.string().test('less-than-or-equal-zero', 'O valor deve ser negativo', (value) => {
      if (!value || value.trim() === '') return true
      const numericValue = Number(value)
      return !isNaN(numericValue) && numericValue <= 0
    })
  })
)
